export function serverStatus() {
    return true;
}